import React, { useEffect } from "react";
import "./Timer.module.css";
import useGameStore from "../../context/GameContext";

const Timer: React.FC = () => {
  const { isTimerRunning, updateTimerElapsed, getFormattedTime } =
    useGameStore();

  // 设置定时器来更新经过的时间
  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;

    if (isTimerRunning) {
      intervalId = setInterval(() => {
        updateTimerElapsed();
      }, 500); // 每500毫秒更新一次，保持UI平滑
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [isTimerRunning, updateTimerElapsed]);

  return (
    <div className="timer">
      <span className="timer-icon">⏳</span>
      <span className="timer-text">{getFormattedTime()}</span>
    </div>
  );
};

export default Timer;
